import { createAsyncAction, action } from 'typesafe-actions'
import { Dispatch } from 'redux'
import api from 'api/graphql/graphql'
import { MatchUpStatBucket } from 'types/global'
import { MILLISECONDS_SINCE_WTN_DATE_START } from 'constants/profile'
import { generateDateAtMidnight } from 'utils'
import { GameType } from 'components/chart/ResultsDoughnutChart/ResultsDoughnutChartTypes'

export const UPDATE_DATE_FILTER_RANGE = 'results/UPDATE_DATE_FILTER_RANGE'
export const setDateFilterRange = (range: number) => action(UPDATE_DATE_FILTER_RANGE, range)

export const TOURNAMENT_GRAPH_YEAR_FILTER_UPDATED = 'results/UPDATE_YEAR_IN_TOURNAMENT_GRAPH'
export const setTournamentChartYearFilter = (year: number) =>
  action(TOURNAMENT_GRAPH_YEAR_FILTER_UPDATED, year)
export const TOURNAMENT_GRAPH_GAME_TYPE_FILTER_UPDATED =
  'results/UPDATE_GAME_TYPE_IN_TOURNAMENT_GRAPH'
export const setTournamentChartGameTypeFilter = (gameType: GameType) =>
  action(TOURNAMENT_GRAPH_GAME_TYPE_FILTER_UPDATED, gameType)

export const RESULTS_SUMMARY_REQUESTED = 'results/RESULTS_SUMMARY_REQUESTED'
export const RESULTS_SUMMARY_COMPLETED = 'results/RESULTS_SUMMARY_COMPLETED'
export const RESULTS_SUMMARY_REQUEST_FAILED = 'results/RESULTS_SUMMARY_REQUEST_FAILED'
export const requestResultsSummary = createAsyncAction(
  RESULTS_SUMMARY_REQUESTED,
  RESULTS_SUMMARY_COMPLETED,
  RESULTS_SUMMARY_REQUEST_FAILED
)<void, any, Error>()

export const TOURN_WIN_LOSS_REQUESTED = 'results/RESULTS_SUMMARY_REQUESTED'
export const TOURN_WIN_LOSS_COMPLETED = 'results/TOURN_WIN_LOSS_COMPLETED'
export const TOURN_WIN_LOSS_FAILED = 'results/TOURN_WIN_LOSS_FAILED'
export const requestTournWinLoss = createAsyncAction(
  TOURN_WIN_LOSS_REQUESTED,
  TOURN_WIN_LOSS_COMPLETED,
  TOURN_WIN_LOSS_FAILED
)<void, MatchUpStatBucket[], Error>()

export const fetchAggregatedResults = (playerId: string, timePeriod: number | null, defaultStartDate: string | undefined) => {
  const start = timePeriod ?? MILLISECONDS_SINCE_WTN_DATE_START
  const today = new Date().getTime()
  const range = Math.abs(today - start)

  return async (dispatch: Dispatch) => {
    await api
      .resultsSummaryQuery(
        playerId,
        defaultStartDate ? generateDateAtMidnight({dateInput: defaultStartDate}).toISOString() : generateDateAtMidnight({ dateInput: range }).toISOString(),
        generateDateAtMidnight({ endOfDay: true }).toISOString()
      )
      .then(data => {
        dispatch(requestResultsSummary.success(data))
      })
      .catch(e => {
        dispatch(requestResultsSummary.failure(e.message))
      })
  }
}

export const fetchTournamentWinLoss = (playerId: string, year: number, matchType: GameType) => {
  return async (dispatch: Dispatch) => {
    try {
      const date = new Date()
      date.setFullYear(year, 0, 1)
      date.setHours(0, 0, 0, 0)
      const startFrom = date.toISOString()
      date.setMonth(11, 31)
      date.setHours(23, 59, 59)
      const startTo = date.toISOString()

      dispatch(requestTournWinLoss.request())
      dispatch(
        requestTournWinLoss.success(
          await api.getTournamentWinLoss(playerId, startFrom, startTo, matchType)
        )
      )
    } catch (e) {
      // @ts-ignore
      console.log('Could not fetch tournament info', e?.message)
      dispatch(requestTournWinLoss.failure(e as Error))
    }
  }
}
